import { translatableFactory } from '../dependencies';
import { intlData, antdData } from '../config';

export default translatableFactory(intlData, antdData);
